import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-export',
  templateUrl: './company-export.component.html',
  styleUrls: ['./company-export.component.css']
})
export class CompanyExportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/company-export/company-export.component.ts